import { SENTRY_IGNORE_ERRORS, sentryBeforeSend } from '@agilox/sentry';
import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import * as Sentry from '@sentry/angular';

import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

if (environment.production) {
	enableProdMode();

	Sentry.init({
		dsn: 'https://94b647d788659ead417902ea409a783e@o919676.ingest.us.sentry.io/4507062554853376',
		replaysSessionSampleRate: 0.1,
		replaysOnErrorSampleRate: 1.0,
		integrations: [
			Sentry.browserTracingIntegration(),
			Sentry.replayIntegration({
				networkDetailAllowUrls: ['https://lifecycle.agilox.net'],
				networkCaptureBodies: true,
			}),
		],
		tracePropagationTargets: ['https://lifecycle.agilox.net'],
		ignoreErrors: SENTRY_IGNORE_ERRORS,
		beforeSend: sentryBeforeSend,
		// Set tracesSampleRate to 1.0 to capture 100%
		// of transactions for performance monitoring.
		tracesSampleRate: 0.5,
	});
}

bootstrapApplication(AppComponent, {
	...appConfig,
	providers: [provideZoneChangeDetection(), ...appConfig.providers],
}).catch((err) => console.error(err));
